/**
 * "Not found" component
 * - Show this if something is missing or not found
 */

import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import Loader from '../Loader/Loader';

type Props = {
  target?:
    | 'general'
    | 'shop'
    | 'page'
    | 'search'
    | 'product'
    | 'products'
    | 'category'
    | 'user'
    | 'order'
    | 'purchase'
    | 'brand'
    | 'vouchers';
  customMessage?: string;
  translationOpts?: any;
  isLoginLoading: boolean;
  icon?: ReactElement;
  title?: string;
};

const mapStateToProps = ({ userData }) => ({
  isLoginLoading: userData?.isLoading,
});

const NotFound = (props: Props) => {
  const { target, translationOpts, customMessage, isLoginLoading, icon, title } = props;
  const { t } = useTranslation();

  const translatedMessage = customMessage ? t(customMessage) : t(`components.not-found.target.${target || 'general'}`, translationOpts);

  if (isLoginLoading) {
    return <Loader />;
  }

  return (
    <div className="not-found">
      {
        // Allow specifically set icon to null to hide it
        icon !== null &&
          (icon ? (
            React.cloneElement(icon, { className: 'not-found-icon' })
          ) : (
            <img src="/icons/icon-items-not-found.svg" className="not-found-icon" alt="not found" />
          ))
      }

      <h2 className="not-found-title">{[null, undefined].includes(title) ? t('components.not-found.sorry') : title}</h2>

      <h6 className="not-found-details">{translatedMessage as string}</h6>
    </div>
  );
};

export default connect(mapStateToProps)(NotFound);
